<template>
  <router-view :key="$route.path"></router-view>
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {
    hasSuperAdminPermission () {
      return this.hasAnyPermission('PERM_VIEW_SUPER_PERMISSION')
    }
  },
  methods: {

  }
}
</script>

<style>

</style>
